import React, { forwardRef } from 'react';
import FilteredMultiSelect from 'react-filtered-multiselect';
import PropTypes from 'prop-types';
import './MultiSelect.css';

const MultiSelect = forwardRef((props, ref) => {
  const {
    avaliableOptions,
    selectedOptions,
    handleMultiDeselect,
    handleMultiSelect,
    textProp,
    valueProp,
    title,
    error,
    name,
    disabled,
    fieldRequired
  } = props;

  const multiSelectStyle = {
    filter: 'form-control mb-2',
    button: 'btn btn btn-block btn-default-bg mt-2 mb-2'
  };

  return (
    <div className="form-group">
      {title && (
        <label className="m-0">
          {title}
          {fieldRequired && <span className="field-required">*</span>}
        </label>
      )}
      <div className="row">
        <div className="col-sm-6">
          <label>Disponíveis</label>
          <FilteredMultiSelect
            disabled={disabled}
            buttonText="Adicionar"
            placeholder="Pesquisar para adicionar"
            classNames={{
              ...multiSelectStyle,
              select: 'form-control select-content',
              buttonActive: 'btn btn btn-block btn-primary'
            }}
            onChange={handleMultiSelect}
            options={avaliableOptions}
            selectedOptions={selectedOptions}
            textProp={textProp}
            valueProp={valueProp}
          />
        </div>
        <div className="col-sm-6">
          <label>Selecionados</label>
          <FilteredMultiSelect
            disabled={disabled}
            buttonText="Remover"
            placeholder="Pesquisar para remover"
            classNames={{
              ...multiSelectStyle,
              select: `form-control select-content multiselect-${name} ${
                error ? 'border-danger' : ''
              }`,
              buttonActive: 'btn btn btn-block btn-danger'
            }}
            ref={ref}
            onChange={handleMultiDeselect}
            options={selectedOptions}
            textProp={textProp}
            valueProp={valueProp}
          />
        </div>
      </div>
    </div>
  );
});

MultiSelect.displayName = 'MultiSelect';

MultiSelect.propTypes = {
  avaliableOptions: PropTypes.array,
  selectedOptions: PropTypes.array,
  handleMultiDeselect: PropTypes.func,
  handleMultiSelect: PropTypes.func,
  textProp: PropTypes.string,
  valueProp: PropTypes.string,
  title: PropTypes.string,
  error: PropTypes.bool,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  fieldRequired: PropTypes.bool
};

export default MultiSelect;
